// src/components/Sections/HowItWorksSection/HowItWorksSection.jsx

import React from 'react';
import './HowItWorksSection.scss';

const steps = [
  {
    number: '01',
    label: 'PLAY',
    title: 'Play the courses you already love.',
    description: 'Choose a course and tees, keep score, and save the round to your golf history. The scorecard stays simple so the round stays about golf.'
  },
  {
    number: '02',
    label: 'YOUR PEOPLE',
    title: 'Bring your regular playing partners.',
    description: 'Create a group once. When you play together, shared rounds contribute to handicap-adjusted results and ongoing group standings.'
  },
  {
    number: '03',
    label: 'COMPETE',
    title: 'Play for something, on your schedule.',
    description: 'Tour Series connects participating public-course rounds through a season competition, without requiring everyone to tee off together.'
  },
  {
    number: '04',
    label: 'BELONG',
    title: 'Build a season and a community.',
    description: 'Keep your golf history, follow friends, celebrate milestones, and take part in member experiences as the founding club grows.'
  }
];

export default function HowItWorksSection() {
  return (
    <section id="how-it-works" className="how-it-works section-v2">
      <div className="container">
        <div className="how-it-works__heading">
          <div>
            <p className="eyebrow">One membership · One connected season</p>
            <h2>Your golf should build toward something.</h2>
          </div>
          <p>
            The Tour brings your rounds, playing partners, competition, and community
            together. You still choose where and when to play. Your membership gives
            everything around those rounds a place to live.
          </p>
        </div>

        <div className="how-it-works__steps">
          {steps.map((step) => (
            <article className="how-it-works__step" key={step.number}>
              <span className="how-it-works__number">{step.number}</span>
              <div>
                <p className="how-it-works__label">{step.label}</p>
                <h3>{step.title}</h3>
                <p className="how-it-works__description">{step.description}</p>
              </div>
            </article>
          ))}
        </div>
        <a className="text-link how-it-works__link" href="#how-it-plays">
          See the on-course experience <span aria-hidden="true">→</span>
        </a>
      </div>
    </section>
  );
}
